//Global
const addToCart = function (id) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({
      id: id,
      quantity: 1,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      return fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      });
    })
    .then((response) => response.json())
    .then((cartData) => {
      //console.log(cartData);
      updateShippingThreshold();
      updateCartCount(cartData.item_count);
      updateSubtotal(cartData.total_price);
      updateSideCart(cartData);

      // Open Side Cart
      document.getElementById("side-cart").classList.add("active");
    })
    .catch((error) => console.error("Error adding item to cart:", error));
};

const setSourceForm = function (name, productId, variantId, img, price) {
  let sourceItem = document.querySelector("#side-source #source-item");
  sourceItem.querySelector("img").src = img;
  sourceItem.querySelector(".name").innerText = name;
  sourceItem.querySelector(".price").innerText = price;

  var sourceForm = document.querySelector("#source-form");

  if (!sourceForm) {
    return;
  }

  var nameInput = sourceForm.querySelector("input[name='name']");
  var priceInput = sourceForm.querySelector("input[name='price']");
  var productIdInput = sourceForm.querySelector("input[name='productId']");
  var variantIdInput = sourceForm.querySelector("input[name='variantId']");
  var imgInput = sourceForm.querySelector("input[name='img']");

  if (nameInput) {
    nameInput.value = name || "";
  }

  if (priceInput) {
    priceInput.value = price || "";
  }

  if (productIdInput) {
    productIdInput.value = productId || "";
  }

  if (variantIdInput) {
    variantIdInput.value = variantId || "";
  }

  if (imgInput) {
    imgInput.value = img || "";
  }
};

const setSingleSourceButtons = function () {
  let sourceButtons = document.querySelectorAll(".source-btn");

  if (sourceButtons.length > 0) {
    sourceButtons.forEach(function (singleSourceBtn) {
      singleSourceBtn.addEventListener("click", function (event) {
        event.preventDefault();
        let name = singleSourceBtn.getAttribute("data-title");
        let productId = singleSourceBtn.getAttribute("data-product-id");
        let variantId = singleSourceBtn.getAttribute("data-variant-id");
        let img = singleSourceBtn.getAttribute("data-img");
        let price = singleSourceBtn.getAttribute("data-price");
        let formPrice = Shopify.formatMoney(price).replace(/\.00$/, "");

        console.log("Name:", name);
        console.log("Product ID:", productId);
        console.log("Variant ID:", variantId);
        console.log("Image URL:", img);
        console.log("Price:", formPrice);

        setSourceForm(name, productId, variantId, img, formPrice);

        //document.querySelector("#side-source").classList.add("active");
      });
    });
  }
};

let submitSourceBtn = document.querySelector(".submit-source-btn");

if (submitSourceBtn) {
  submitSourceBtn.addEventListener("click", function (event) {
    event.preventDefault();
    let sourceForm = document.querySelector("#source-form");
    let emailInput = sourceForm.querySelector("input[type='email']");
    let messageInput = sourceForm.querySelector("textarea[name='message']");

    let errorMessage = document.querySelector("#side-source .error");
    let successMessage = document.querySelector("#side-source .success");

    let finalName = sourceForm.querySelector("input[name='name']").value;
    let finalPrice = sourceForm.querySelector("input[name='price']").value;
    let finalProductId = sourceForm.querySelector(
      "input[name='productId']",
    ).value;
    let finalVariantId = sourceForm.querySelector(
      "input[name='variantId']",
    ).value;

    // console.log("Email:", emailInput.value);
    // console.log("Name:", finalName);
    // console.log("Price:", finalPrice);
    // console.log("Product ID:", finalProductId);
    // console.log("Variant ID:", finalVariantId);
    // console.log("Message:", messageInput.value);

    let email = emailInput.value;
    let notes = messageInput.value;

    let subject = "Source Request: " + finalName;

    let body =
      "Contact Email: " +
      email +
      "\n\n" +
      "Name: " +
      finalName +
      "\n" +
      "Product ID: " +
      finalProductId +
      "\n" +
      "Variant ID: " +
      finalVariantId +
      "\n" +
      "Price: " +
      finalPrice +
      "\n\n" +
      "Notes: " +
      notes;

    let mailtoLink =
      "mailto:sourcebagcrap@gmail.com" +
      "?subject=" +
      encodeURIComponent(subject) +
      "&body=" +
      encodeURIComponent(body);

    window.location.href = mailtoLink;

    if (!emailInput || !emailInput.value) {
      errorMessage.classList.add("show");
      emailInput.focus();
      return;
    } else {
      errorMessage.classList.remove("show");
      successMessage.classList.add("show");
    }
  });
}

// const setProduct = function (singleProduct) {
//   if (singleProduct.dataset.status == "dynamic") {
//     return;
//   } else {
//     let addSwiper = singleProduct.querySelector(".swiper-container");

//     var swiper;

//     swiper = new Swiper(addSwiper, {
//       loop: true,
//       navigation: {
//         nextEl: singleProduct.querySelector(".swiper-button-next"),
//         prevEl: singleProduct.querySelector(".swiper-button-prev"),
//       },
//       pagination: {
//         el: singleProduct.querySelector(".swiper-pagination"),
//         clickable: true,
//       },
//     });

//     singleProduct.swiperInstance = swiper;

//     singleProduct.dataset.status = "dynamic";
//   }
// };

const setProduct = function (singleProduct) {
  if (singleProduct.dataset.status == "dynamic") {
    return;
  }

  let addSwiper = singleProduct.querySelector(".swiper-container");

  if (!addSwiper) {
    return;
  }

  var swiper = new Swiper(addSwiper, {
    loop: true,
    navigation: {
      nextEl: singleProduct.querySelector(".swiper-button-next"),
      prevEl: singleProduct.querySelector(".swiper-button-prev"),
    },
    pagination: {
      el: singleProduct.querySelector(".swiper-pagination"),
      clickable: true,
    },
  });

  singleProduct.swiperInstance = swiper;
  singleProduct.dataset.status = "dynamic";
};

const initAjaxProductCards = function (scope) {
  let container = scope || document;
  let products = container.querySelectorAll(".product");

  products.forEach(function (product) {
    setProduct(product);

    let addToCartBtn = product.querySelector(".plp-atc-btn");
    let selectOptions = product.querySelector("select");
    let price = product.querySelector(".plp-btns .price");

    if (!addToCartBtn) {
      return;
    }

    if (product.dataset.atcBound == "true") {
      return;
    }

    if (selectOptions) {
      selectOptions.addEventListener("change", function () {
        let current = selectOptions.options[selectOptions.selectedIndex].value;
        let selectedOption = selectOptions.options[selectOptions.selectedIndex];
        console.log(selectedOption);
        let currentStock = parseInt(selectedOption.dataset.stock);
        let currentTitle = selectedOption.dataset.title;
        let currentImg = selectedOption.dataset.img;
        let currentPrice = selectedOption.dataset.price;
        addToCartBtn.dataset.stock = currentStock;
        addToCartBtn.dataset.name = currentTitle;
        addToCartBtn.dataset.img = currentImg;
        addToCartBtn.dataset.price = currentPrice;
        //console.log("Current Stock:", currentStock);

        if (currentStock == 0) {
          //addToCartBtn.innerHTML = "<span>✉️</span>";
          addToCartBtn.innerHTML = "<span>🛒</span>";
          addToCartBtn.classList.add("add-opacity");
        } else {
          addToCartBtn.innerHTML = "<span>🛒</span>";
          addToCartBtn.classList.remove("add-opacity");
        }

        if (price && selectedOption.dataset.price) {
          let noDecimalPrice = currentPrice.replace(/\.00$/, "");

          if (currentStock == 0) {
            price.classList.add("orange");
            price.innerText = "Sold";
          } else {
            price.classList.remove("orange");
            price.innerText = noDecimalPrice;
          }
        }

        product.classList.add("atc-on");
        addToCartBtn.dataset.atcId = current;

        let swiperSlides = product.querySelectorAll(".swiper-slide");
        let selectedVariantId = current;
        let found = false;

        swiperSlides.forEach(function (slide, index) {
          const variantIds = slide.dataset.variantIds
            ? slide.dataset.variantIds.split(",")
            : [];

          if (variantIds.includes(selectedVariantId)) {
            found = true;

            if (product.swiperInstance) {
              product.swiperInstance.slideToLoop(index);
            }
          }
        });

        if (!found && product.swiperInstance) {
          product.swiperInstance.slideToLoop(0);
        }

        setSourceForm(
          addToCartBtn.dataset.name,
          addToCartBtn.dataset.productId,
          addToCartBtn.dataset.atcId,
          addToCartBtn.dataset.img,
          addToCartBtn.dataset.price,
        );
      });
    }

    addToCartBtn.addEventListener("click", function (event) {
      event.preventDefault();
      let atcStock = parseInt(addToCartBtn.dataset.stock);

      if (addToCartBtn.dataset.atcId) {
        if (atcStock == 0) {
          //document.querySelector("#side-source").classList.add("active");
        } else {
          addToCart(addToCartBtn.dataset.atcId);
        }
      } else {
        console.log("Select a size");
      }
    });

    product.dataset.atcBound = "true";
    setSingleSourceButtons();
  });
};

//plpAddToCart();
initAjaxProductCards(document);

let lastScrollY = window.scrollY;

//Side Cart Button
let main = document.querySelector("main");
let openCart = document.querySelectorAll(".cart-btn");

openCart.forEach((btn) => {
  btn.addEventListener("click", (event) => {
    event.preventDefault();

    document.querySelector("body").classList.add("prevent-scroll");

    document.querySelector("#top-search").classList.remove("active");
    document.querySelector("#top-search").classList.remove("animate-lg");
    document.querySelector(".mobile-nav").classList.remove("active");
    document.querySelector(".mobile-nav").classList.remove("animate-lg");
    let menuBtn = document.querySelectorAll(".menu-btn");
    menuBtn.forEach((btn) => {
      btn.classList.remove("close");
    });
    document.querySelector("header").classList.remove("is-active");

    document.querySelector("#side-cart").classList.toggle("animate-lg");
    document.querySelector("#side-cart").classList.toggle("active");
  });
});

//Close Side Cart Button
let closeCart = document.querySelectorAll(".close-cart-btn");

closeCart.forEach((btn) => {
  btn.addEventListener("click", (event) => {
    event.preventDefault();
    let cart = document.querySelector("#side-cart");
    cart.classList.remove("active");
    document.querySelector("body").classList.remove("prevent-scroll");
  });
});

//Close Source Button
let closeSource = document.querySelectorAll(".close-source-btn");

closeSource.forEach((btn) => {
  btn.addEventListener("click", (event) => {
    event.preventDefault();
    let source = document.querySelector("#side-source");
    source.classList.remove("active");
  });
});

let menuBtn = document.querySelectorAll(".menu-btn");

menuBtn.forEach((btn) => {
  btn.addEventListener("click", (event) => {
    event.preventDefault();
    document.querySelector("#top-search").classList.remove("active");
    document.querySelector("#top-search").classList.remove("animate-lg");
    document.querySelector("#side-cart").classList.remove("active");
    document.querySelector("#side-cart").classList.remove("animate-lg");

    document.querySelector("body").classList.remove("prevent-scroll");

    btn.classList.toggle("close");
    //document.querySelector("main").classList.toggle("hide");
    //document.querySelector("header").classList.toggle("is-active");
    document.querySelector(".mobile-nav").classList.toggle("animate-lg");
    document.querySelector(".mobile-nav").classList.toggle("active");
  });
});

let searchBtn = document.querySelectorAll(".search-btn");

searchBtn.forEach((btn) => {
  btn.addEventListener("click", (event) => {
    event.preventDefault();
    document.querySelector("#side-cart").classList.remove("active");
    document.querySelector("#side-cart").classList.remove("animate-lg");
    document.querySelector(".mobile-nav").classList.remove("active");
    document.querySelector(".mobile-nav").classList.remove("animate-lg");
    document.querySelector("header").classList.remove("is-active");
    document.querySelector("body").classList.remove("prevent-scroll");
    let menuBtn = document.querySelectorAll(".menu-btn");
    menuBtn.forEach((btn) => {
      btn.classList.remove("close");
    });

    document.querySelector("main").classList.toggle("hide");
    document.querySelector("#top-search").classList.toggle("animate-lg");
    document.querySelector("#top-search").classList.toggle("active");
    document.querySelector("#search-form").focus();
  });
});

//Menu Dropdown
let navChild = document.querySelectorAll(".has-child");

navChild.forEach((child) => {
  child.addEventListener("click", (event) => {
    event.preventDefault();
    child.classList.toggle("active");
  });
});

let desktopSearchBtn = document.querySelector(".desktop-search-btn");

desktopSearchBtn.addEventListener("click", (event) => {
  event.preventDefault();
  document.querySelector("#desktop-search-input").focus();
});

//Newsletter
let newsletterFormWrap = document.querySelectorAll(".newsletter-form-wrap");
if (newsletterFormWrap.length > 0) {
  newsletterFormWrap.forEach(function (item) {
    let newsletterForm = item.querySelector("form");
    let newsletterEmail = item.querySelector("#newsletter-email");
    let successMessage = item.querySelector(".success");

    newsletterForm.addEventListener("submit", function (event) {
      event.preventDefault();

      const emailValue = newsletterEmail.value;

      const payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: emailValue,
                  properties: {
                    "website-source": "email-capture",
                  },
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "VQDrRH",
              },
            },
          },
        },
      };

      const requestOptions = {
        method: "POST",
        headers: {
          "content-type": "application/vnd.api+json",
          revision: "2024-10-15",
        },
        body: JSON.stringify(payload),
      };

      fetch(
        "https://a.klaviyo.com/client/subscriptions?company_id=XRLAjE",
        requestOptions,
      )
        .then((res) => {
          if (res.ok) {
            // Check if there is content to parse
            return res.text().then((text) => (text ? JSON.parse(text) : {}));
          } else {
            return res.json().then((errorDetails) => {
              throw new Error(`Failed to subscribe: ${errorDetails.message}`);
            });
          }
        })
        .then((res) => {
          //console.log('Submission successful:', res);
          newsletterEmail.classList.add("hide");
          successMessage.classList.remove("hide");
        })
        .catch((err) => {
          //console.error('Error occurred:', err);
          //successMessage.classList.add('hide');
        });
    });
  });
}

let newsletterBtn = document.querySelectorAll(".newsletter-btn");

if (newsletterBtn.length > 0) {
  newsletterBtn.forEach(function (item) {
    item.addEventListener("click", function (event) {
      event.preventDefault();

      console.log("Newsletter button clicked");

      if (window.klaviyo) {
        window.klaviyo.openForm("YejZ4Y");
      } else {
        console.log("Klaviyo has not loaded");
      }
    });
  });
}

//Mobile Nav Dropdown
let mobileDropDown = document.querySelectorAll(".mobile-nav .dropdown");

mobileDropDown.forEach((child) => {
  let dropBtn = child.querySelector(".drop-btn");
  dropBtn.addEventListener("click", (event) => {
    event.preventDefault();
    child.classList.toggle("active");
  });
});

//Marquee Clone
let marquees = document.querySelectorAll(".marquee");

if (marquees.length > 0) {
  marquees.forEach((marquee) => {
    let inner = marquee.querySelector(".inner");
    if (!inner) return;

    for (let i = 0; i < 6; i++) {
      marquee.appendChild(inner.cloneNode(true));
    }
  });
}

const addSingleProductToCart = function (variantID) {};


// Main Loop
var mainLoop = document.querySelectorAll(".main-loop");

if (mainLoop.length > 0) {
  mainLoop.forEach(function (container) {
    if (container.getAttribute("data-show-more-initialized") === "true") {
      return;
    }

    container.setAttribute("data-show-more-initialized", "true");

    var showMoreButton = container.querySelector(".show-more-btn");
    var viewAllButton = container.querySelector(".view-all-btn");
    var loop = container.querySelector(".loop");
    var collectionHandle = container.getAttribute("data-collection-handle");

    var pageParams = new URLSearchParams(window.location.search);
    var sortBy =
      pageParams.get("sort_by") ||
      container.getAttribute("data-sort-by") ||
      "";

    if ((!showMoreButton && !viewAllButton) || !loop || !collectionHandle) {
      return;
    }

    var isLoading = false;

    function setButtonsLoading(isViewAll) {
      if (showMoreButton) {
        showMoreButton.disabled = true;
      }

      if (viewAllButton) {
        viewAllButton.disabled = true;
      }

      if (isViewAll && viewAllButton) {
        viewAllButton.textContent = "Loading All...";
      } else if (showMoreButton) {
        showMoreButton.textContent = "Loading...";
      }
    }

    function resetButtons() {
      if (showMoreButton) {
        showMoreButton.disabled = false;
        showMoreButton.textContent = "Show More";
      }

      if (viewAllButton) {
        viewAllButton.disabled = false;
        viewAllButton.textContent = "View All";
      }
    }

    function removePaginationButtons() {
      if (showMoreButton) {
        showMoreButton.remove();
        showMoreButton = null;
      }

      if (viewAllButton) {
        viewAllButton.remove();
        viewAllButton = null;
      }
    }

    function getProductKey(item) {
      if (!item) {
        return null;
      }

      var productElement = item.matches("[data-product-id], [data-product-handle]")
        ? item
        : item.querySelector("[data-product-id], [data-product-handle]");

      if (productElement) {
        return (
          productElement.getAttribute("data-product-id") ||
          productElement.getAttribute("data-product-handle")
        );
      }

      var productLink = item.matches("a[href*='/products/']")
        ? item
        : item.querySelector("a[href*='/products/']");

      if (productLink) {
        return productLink.getAttribute("href").split("?")[0];
      }

      return null;
    }

    function getExistingProductKeys() {
      var keys = new Set();

      Array.prototype.forEach.call(loop.children, function (item) {
        var key = getProductKey(item);

        if (key) {
          keys.add(key);
        }
      });

      return keys;
    }

    function appendNewProducts(ajaxProducts) {
      var tempWrap = document.createElement("div");
      tempWrap.innerHTML = ajaxProducts.innerHTML;

      var existingKeys = getExistingProductKeys();
      var newItems = Array.prototype.slice.call(tempWrap.children);

      newItems.forEach(function (item) {
        var key = getProductKey(item);

        if (key && existingKeys.has(key)) {
          return;
        }

        loop.appendChild(item);

        if (key) {
          existingKeys.add(key);
        }
      });
    }

    function loadPage(page, loadAll) {
      var params = new URLSearchParams();

      params.set("view", "ajax-main");
      params.set("page", page);

      if (sortBy) {
        params.set("sort_by", sortBy);
      }

      var url = "/collections/" + collectionHandle + "?" + params.toString();

      return fetch(url)
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Failed to load products");
          }

          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var ajaxProducts = doc.querySelector(".ajax-products");

          if (!ajaxProducts) {
            removePaginationButtons();
            return false;
          }

          appendNewProducts(ajaxProducts);

          var returnedPage = parseInt(
            ajaxProducts.getAttribute("data-current-page"),
            10
          );

          var pageToStore = isNaN(returnedPage) ? page : returnedPage;

          container.setAttribute("data-current-page", pageToStore);

          var currentPageElement = container.querySelector(".current-page");

          if (currentPageElement) {
            currentPageElement.textContent = pageToStore;
          }

          if (typeof initAjaxProductCards === "function") {
            initAjaxProductCards(container);
          }

          var hasNextPage =
            ajaxProducts.getAttribute("data-has-next-page") === "true";

          if (loadAll && hasNextPage) {
            return loadPage(page + 1, true);
          }

          return hasNextPage;
        });
    }

    function startLoading(loadAll) {
      if (isLoading) {
        return;
      }

      isLoading = true;
      setButtonsLoading(loadAll);

      var currentPage = parseInt(
        container.getAttribute("data-current-page"),
        10
      );

      if (isNaN(currentPage)) {
        currentPage = 1;
      }

      loadPage(currentPage + 1, loadAll)
        .then(function (hasNextPage) {
          if (!hasNextPage || loadAll) {
            removePaginationButtons();
            return;
          }

          resetButtons();
        })
        .catch(function (error) {
          console.error(error);
          resetButtons();

          if (loadAll && viewAllButton) {
            viewAllButton.textContent = "Try Again";
          } else if (showMoreButton) {
            showMoreButton.textContent = "Try Again";
          }
        })
        .finally(function () {
          isLoading = false;
        });
    }

    if (showMoreButton) {
      showMoreButton.addEventListener("click", function (event) {
        event.preventDefault();
        startLoading(false);
      });
    }

    if (viewAllButton) {
      viewAllButton.addEventListener("click", function (event) {
        event.preventDefault();
        startLoading(true);
      });
    }
  });
}

// var mainLoop = document.querySelectorAll(".main-loop");

// if (mainLoop.length > 0) {
//   mainLoop.forEach(function (container) {
//     var showMoreButton = container.querySelector(".show-more-btn");
//     var viewAllButton = container.querySelector(".view-all-btn");
//     var loop = container.querySelector(".loop");
//     var collectionHandle = container.getAttribute("data-collection-handle");

//     if ((!showMoreButton && !viewAllButton) || !loop || !collectionHandle) {
//       return;
//     }

//     var isLoading = false;

//     function setButtonsLoading(isViewAll) {
//       if (showMoreButton) {
//         showMoreButton.disabled = true;
//       }

//       if (viewAllButton) {
//         viewAllButton.disabled = true;
//       }

//       if (isViewAll && viewAllButton) {
//         viewAllButton.textContent = "Loading All...";
//       } else if (showMoreButton) {
//         showMoreButton.textContent = "Loading...";
//       }
//     }

//     function resetButtons() {
//       if (showMoreButton) {
//         showMoreButton.disabled = false;
//         showMoreButton.textContent = "Show More";
//       }

//       if (viewAllButton) {
//         viewAllButton.disabled = false;
//         viewAllButton.textContent = "View All";
//       }
//     }

//     function removePaginationButtons() {
//       if (showMoreButton) {
//         showMoreButton.remove();
//         showMoreButton = null;
//       }

//       if (viewAllButton) {
//         viewAllButton.remove();
//         viewAllButton = null;
//       }
//     }

//     function loadPage(page, loadAll) {
//       var url =
//         "/collections/" + collectionHandle + "?view=ajax-main&page=" + page;

//       return fetch(url)
//         .then(function (response) {
//           if (!response.ok) {
//             throw new Error("Failed to load products");
//           }

//           return response.text();
//         })
//         .then(function (html) {
//           var parser = new DOMParser();
//           var doc = parser.parseFromString(html, "text/html");
//           var ajaxProducts = doc.querySelector(".ajax-products");

//           if (!ajaxProducts) {
//             removePaginationButtons();
//             return false;
//           }

//           var tempWrap = document.createElement("div");
//           tempWrap.innerHTML = ajaxProducts.innerHTML;

//           while (tempWrap.firstChild) {
//             loop.appendChild(tempWrap.firstChild);
//           }

//           container.setAttribute("data-current-page", page);

//           var currentPageElement = container.querySelector(".current-page");

//           if (currentPageElement) {
//             currentPageElement.textContent = page;
//           }

//           if (typeof initAjaxProductCards === "function") {
//             initAjaxProductCards(container);
//           }

//           var hasNextPage =
//             ajaxProducts.getAttribute("data-has-next-page") === "true";

//           if (loadAll && hasNextPage) {
//             return loadPage(page + 1, true);
//           }

//           return hasNextPage;
//         });
//     }

//     function startLoading(loadAll) {
//       if (isLoading) {
//         return;
//       }

//       isLoading = true;
//       setButtonsLoading(loadAll);

//       var currentPage = parseInt(
//         container.getAttribute("data-current-page"),
//         10,
//       );

//       loadPage(currentPage + 1, loadAll)
//         .then(function (hasNextPage) {
//           if (!hasNextPage || loadAll) {
//             removePaginationButtons();
//             return;
//           }

//           resetButtons();
//         })
//         .catch(function (error) {
//           console.error(error);
//           resetButtons();

//           if (loadAll && viewAllButton) {
//             viewAllButton.textContent = "Try Again";
//           } else if (showMoreButton) {
//             showMoreButton.textContent = "Try Again";
//           }
//         })
//         .finally(function () {
//           isLoading = false;
//         });
//     }

//     if (showMoreButton) {
//       showMoreButton.addEventListener("click", function () {
//         startLoading(false);
//       });
//     }

//     if (viewAllButton) {
//       viewAllButton.addEventListener("click", function (event) {
//         event.preventDefault();
//         startLoading(true);
//       });
//     }
//   });
// }

// if (mainLoop.length > 0) {
//   mainLoop.forEach(function (container) {
//     var button = container.querySelector(".show-more-btn");
//     var loop = container.querySelector(".loop");
//     var collectionHandle = container.getAttribute("data-collection-handle");
//     var totalPages = container.querySelector(".total-pages");

//     if (!button || !loop || !collectionHandle) {
//       return;
//     }

//     var isLoading = false;

//     button.addEventListener("click", function () {
//       if (isLoading) {
//         return;
//       }

//       isLoading = true;
//       button.disabled = true;
//       button.textContent = "Loading...";

//       var currentPage = parseInt(
//         container.getAttribute("data-current-page"),
//         10,
//       );
//       var nextPage = currentPage + 1;

//       var url =
//         "/collections/" + collectionHandle + "?view=ajax-main&page=" + nextPage;

//       fetch(url)
//         .then(function (response) {
//           if (!response.ok) {
//             throw new Error("Failed to load products");
//           }

//           return response.text();
//         })
//         .then(function (html) {
//           var parser = new DOMParser();
//           var doc = parser.parseFromString(html, "text/html");
//           var ajaxProducts = doc.querySelector(".ajax-products");

//           if (!ajaxProducts) {
//             button.remove();
//             return;
//           }

//           var tempWrap = document.createElement("div");
//           tempWrap.innerHTML = ajaxProducts.innerHTML;

//           while (tempWrap.firstChild) {
//             loop.appendChild(tempWrap.firstChild);
//           }

//           container.setAttribute("data-current-page", nextPage);

//           container.querySelector(".current-page").innerHTML = nextPage;

//           var hasNextPage = ajaxProducts.getAttribute("data-has-next-page");

//           if (hasNextPage !== "true") {
//             button.remove();
//           } else {
//             button.disabled = false;
//             button.textContent = "Show More";
//           }

//           if (typeof initAjaxProductCards === "function") {
//             initAjaxProductCards(container);
//           }
//         })
//         .catch(function (error) {
//           console.error(error);
//           button.disabled = false;
//           button.textContent = "Try Again";
//         })
//         .finally(function () {
//           isLoading = false;
//         });
//     });
//   });
// }

var showMoreCollections = document.querySelectorAll(".show-more-collection");

var showMoreCollections = document.querySelectorAll(".show-more-collection");

if (showMoreCollections.length > 0) {
  showMoreCollections.forEach(function (container) {
    var showMoreButton = container.querySelector(".show-more-btn");
    var viewAllButton = container.querySelector(".view-all-btn");
    var loop = container.querySelector(".show-more-loop");
    var collectionHandle = container.getAttribute("data-collection-handle");

    if ((!showMoreButton && !viewAllButton) || !loop || !collectionHandle) {
      return;
    }

    var isLoading = false;

    function setButtonsLoading(isViewAll) {
      if (showMoreButton) {
        showMoreButton.disabled = true;
      }

      if (viewAllButton) {
        viewAllButton.disabled = true;
      }

      if (isViewAll && viewAllButton) {
        viewAllButton.textContent = "Loading All...";
      } else if (showMoreButton) {
        showMoreButton.textContent = "Loading...";
      }
    }

    function resetButtons() {
      if (showMoreButton) {
        showMoreButton.disabled = false;
        showMoreButton.textContent = "Show More";
      }

      if (viewAllButton) {
        viewAllButton.disabled = false;
        viewAllButton.textContent = "View All";
      }
    }

    function removeButtons() {
      if (showMoreButton) {
        showMoreButton.remove();
        showMoreButton = null;
      }

      if (viewAllButton) {
        viewAllButton.remove();
        viewAllButton = null;
      }
    }

    function loadPage(page, loadAll) {
      var url =
        "/collections/" +
        collectionHandle +
        "?view=ajax-show-more&page=" +
        page;

      return fetch(url)
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Failed to load products");
          }

          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var ajaxProducts = doc.querySelector(".ajax-products");

          if (!ajaxProducts) {
            removeButtons();
            return false;
          }

          var tempWrap = document.createElement("div");
          tempWrap.innerHTML = ajaxProducts.innerHTML;

          while (tempWrap.firstChild) {
            loop.appendChild(tempWrap.firstChild);
          }

          container.setAttribute("data-current-page", page);

          if (typeof initAjaxProductCards === "function") {
            initAjaxProductCards(container);
          }

          var hasNextPage =
            ajaxProducts.getAttribute("data-has-next-page") === "true";

          if (loadAll && hasNextPage) {
            return loadPage(page + 1, true);
          }

          return hasNextPage;
        });
    }

    function startLoading(loadAll) {
      if (isLoading) {
        return;
      }

      isLoading = true;
      setButtonsLoading(loadAll);

      var currentPage = parseInt(
        container.getAttribute("data-current-page"),
        10,
      );

      loadPage(currentPage + 1, loadAll)
        .then(function (hasNextPage) {
          if (!hasNextPage || loadAll) {
            removeButtons();
            return;
          }

          resetButtons();
        })
        .catch(function (error) {
          console.error(error);

          if (showMoreButton) {
            showMoreButton.disabled = false;
            showMoreButton.textContent = "Try Again";
          }

          if (viewAllButton) {
            viewAllButton.disabled = false;
            viewAllButton.textContent = "Try Again";
          }
        })
        .finally(function () {
          isLoading = false;
        });
    }

    if (showMoreButton) {
      showMoreButton.addEventListener("click", function () {
        startLoading(false);
      });
    }

    if (viewAllButton) {
      viewAllButton.addEventListener("click", function (event) {
        //event.preventDefault();
        //startLoading(true);
      });
    }
  });
}
// if (showMoreCollections.length > 0) {
//   showMoreCollections.forEach(function (container) {
//     var button = container.querySelector(".show-more-btn");
//     var loop = container.querySelector(".show-more-loop");
//     var collectionHandle = container.getAttribute("data-collection-handle");

//     if (!button || !loop || !collectionHandle) {
//       return;
//     }

//     var isLoading = false;

//     button.addEventListener("click", function () {
//       if (isLoading) {
//         return;
//       }

//       isLoading = true;
//       button.disabled = true;
//       button.textContent = "Loading...";

//       var currentPage = parseInt(
//         container.getAttribute("data-current-page"),
//         10,
//       );
//       var nextPage = currentPage + 1;

//       var url =
//         "/collections/" +
//         collectionHandle +
//         "?view=ajax-show-more&page=" +
//         nextPage;

//       fetch(url)
//         .then(function (response) {
//           if (!response.ok) {
//             throw new Error("Failed to load products");
//           }

//           return response.text();
//         })
//         .then(function (html) {
//           var parser = new DOMParser();
//           var doc = parser.parseFromString(html, "text/html");
//           var ajaxProducts = doc.querySelector(".ajax-products");

//           if (!ajaxProducts) {
//             button.remove();
//             return;
//           }

//           var tempWrap = document.createElement("div");
//           tempWrap.innerHTML = ajaxProducts.innerHTML;

//           while (tempWrap.firstChild) {
//             loop.appendChild(tempWrap.firstChild);
//           }

//           container.setAttribute("data-current-page", nextPage);

//           var hasNextPage = ajaxProducts.getAttribute("data-has-next-page");

//           if (hasNextPage !== "true") {
//             button.remove();
//           } else {
//             button.disabled = false;
//             button.textContent = "Show More";
//           }

//           if (typeof initAjaxProductCards === "function") {
//             initAjaxProductCards(container);
//           }
//         })
//         .catch(function (error) {
//           console.error(error);
//           button.disabled = false;
//           button.textContent = "Try Again";
//         })
//         .finally(function () {
//           isLoading = false;
//         });
//     });
//   });
// }

setSingleSourceButtons();

//Order Note
let orderNoteBtn = document.querySelector(".order-note-btn");
let orderGiftNote = document.querySelector("#gift-note");

if (orderNoteBtn) {
  orderNoteBtn.addEventListener("click", function (event) {
    event.preventDefault();
    orderGiftNote.classList.toggle("show");
    orderGiftNote.focus();
  });
}

//Custom Chat Button
// function findInShadowRoots(selector, root = document) {
//   const match = root.querySelector(selector);

//   if (match) {
//     return match;
//   }

//   for (const element of root.querySelectorAll("*")) {
//     if (!element.shadowRoot) {
//       continue;
//     }

//     const shadowMatch = findInShadowRoots(selector, element.shadowRoot);

//     if (shadowMatch) {
//       return shadowMatch;
//     }
//   }

//   return null;
// }

// let shopifyChatActivator = null;

// function openShopifyChat() {
//   if (shopifyChatActivator?.isConnected) {
//     shopifyChatActivator.click();
//     return;
//   }

//   const interval = setInterval(() => {
//     shopifyChatActivator = findInShadowRoots(
//       'button[part="activator"], button[aria-label="Open chat"]',
//     );

//     if (!shopifyChatActivator) {
//       return;
//     }

//     clearInterval(interval);
//     shopifyChatActivator.click();
//   }, 100);
// }

// document.addEventListener("click", (e) => {
//   if (!e.target.closest(".chat-btn")) {
//     return;
//   }

//   e.preventDefault();
//   openShopifyChat();
// });